import { createReducer, on } from '@ngrx/store';
import { videosActions } from '../actions/videos.actions';
import { Video } from '../models';

export interface VideosState {
    videos: Record<string, { loaded: boolean; loading: boolean | null; video: Video | null }>;
}

export const initialState: VideosState = {
    videos: {},
};

export const videosReducer = createReducer(
    initialState,
    on(videosActions.getVideo, (state, action): VideosState => {
        if (state.videos[action.id]) {
            return state;
        }

        return {
            ...state,
            videos: {
                ...state.videos,
                [action.id]: { loaded: false, loading: null, video: null },
            },
        };
    }),
    on(
        videosActions.getVideoSuccess,
        (state, payload): VideosState => ({
            ...state,
            videos: {
                ...state.videos,
                [payload.video.id]: { loaded: true, loading: false, video: payload.video },
            },
        }),
    ),
    on(
        videosActions.getVideoError,
        (state, payload): VideosState => ({
            ...state,
            videos: {
                ...state.videos,
                [payload.video.id]: { loaded: false, loading: false, video: null },
            },
        }),
    ),
    on(
        videosActions.setLoading,
        (state, payload): VideosState => ({
            ...state,
            videos: {
                ...state.videos,
                [payload.id]: { loaded: false, loading: true, video: null },
            },
        }),
    ),
    on(
        videosActions.clear,
        (): VideosState => ({
            ...initialState,
        }),
    ),
);
